module.exports = __webpack_public_path__ + "img/blockGq2-3.62506164.svg";